/**
 * Arka plandaki sekmede de düzenli çalışan zamanlayıcı.
 *
 * Chrome, gizli sekmelerde ana iş parçacığının zamanlayıcılarını dakikada bire
 * kadar kısıyor. Toplantı sırasında TalkNote sekmesinin arkada durması olağan;
 * Deepgram bağlantısını duraklatmada canlı tutan sinyal (4 sn) bu yüzden bir
 * işçide sayılıyor — işçi zamanlayıcıları bu kısıtlamaya takılmıyor.
 */

type Callback = () => void;

let worker: Worker | null = null;
let failed = false;
let nextId = 1;
const callbacks = new Map<number, Callback>();

function getWorker(): Worker | null {
  if (worker || failed) return worker;
  try {
    worker = new Worker(new URL('./tickerWorker.ts', import.meta.url), { type: 'module' });
    worker.onmessage = (event: MessageEvent<number>) => callbacks.get(event.data)?.();
  } catch (err) {
    console.warn('[ticker] işçi açılamadı, sayfa zamanlayıcısı kullanılıyor:', err);
    failed = true;
  }
  return worker;
}

/** `ms` aralıkla `callback`'i çağırır; dönen fonksiyon durdurur. */
export function interval(ms: number, callback: Callback): () => void {
  const target = getWorker();
  if (!target) {
    const handle = window.setInterval(callback, ms);
    return () => window.clearInterval(handle);
  }
  const id = nextId++;
  callbacks.set(id, callback);
  target.postMessage({ type: 'start', id, ms });
  return () => {
    callbacks.delete(id);
    target.postMessage({ type: 'stop', id });
  };
}
